module.exports = __webpack_public_path__ + "static/full14-0b0293a838b415dfdab56ddb10baa041.png";